import { CheckOperation } from "@workspace/operations/check-operation";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "@workspace/ui/components/dialog";

import { useEposContext } from "../epos-context";
import { EposLeftPanel } from "./epos-left-panel";
import { EposRightPanel } from "./epos-right-panel";
import { PrintReceiptButton } from "./print-receipt-button";

export function EposSystem() {
	const {
		currentOrder,
		lastCompletedOrder,
		isReceiptModalOpen,
		setIsReceiptModalOpen,
		selectedStaff,
		receiptOperations,
	} = useEposContext();

	// The order completes and the active-order state resets to staff-select while
	// the receipt modal stays up, so render the captured completed order (HA-583).
	const receiptOrder = lastCompletedOrder ?? currentOrder;

	return (
		<div className="grid h-full grid-cols-1 gap-2 md:grid-cols-3 w-full">
			<EposLeftPanel />

			{selectedStaff && <EposRightPanel />}

			{isReceiptModalOpen && (
				<Dialog open={isReceiptModalOpen} onOpenChange={setIsReceiptModalOpen}>
					<DialogContent className="sm:max-w-[400px]">
						<DialogHeader>
							<DialogTitle>Receipt</DialogTitle>
							<DialogDescription>
								Payment completed successfully
							</DialogDescription>
						</DialogHeader>
						{receiptOrder && (
							<div className="space-y-4 py-4">
								<div className="rounded-md border p-4 text-center font-mono text-sm">
									<div>Order #{receiptOrder.id}</div>
									<div className="text-muted-foreground">
										{new Date(
											receiptOrder.completedAt || receiptOrder.updatedAt,
										).toLocaleString()}
									</div>
								</div>
								<div className="flex justify-center gap-2">
									{/* HA-360 AC2: gated like the other print buttons; the server also refuses without epos:receipt:print. */}
									<CheckOperation
										operation="staff-terminal-print-receipt"
										operations={receiptOperations ?? []}
									>
										<PrintReceiptButton orderId={receiptOrder.id} />
									</CheckOperation>
								</div>
							</div>
						)}
					</DialogContent>
				</Dialog>
			)}
		</div>
	);
}
